export const SPIN_LAUNCHER_TRIGGER_EVENT = 'raychat_btn_shake'
export const OPEN_WIDGET = 'raychat_open_container'
export const CLOSE_WIDGET = 'raychat_close_container'
export const SHOW_AUTO_MSG_IN_GREETING_DIALOGUE = 'raychat_send_message'
export const OPEN_WIDGET_AND_SEND_MESSAGE = 'raychat_send_message_open'
